import React from "react";
import styled from "styled-components";
import {rgb_121_121_121} from "../../colors";
import {w_px11rate, w_px80rate} from "../../size";

const ListName = ({ children,style }) => {
  return <Name style={{...style}}>{children}</Name>;
};

export default React.memo(ListName);

const Name = styled.div`
  width: ${w_px80rate}px;
  font-size: ${w_px11rate}px;
  font-family: noto_sans_kr_regular;
  color: ${rgb_121_121_121};
`;
